import React from 'react';
import styles from './index.module.scss';
import Lottie from 'lottie-react';
import loaderAnimation from '../../assets/lotties/loader.json';

/**
 * @param {{ noBackground?: boolean; text?: string }} props
 */
// Optional text prop to show a message below the spinner
const Loader = ({ noBackground, text }) => {
  return (
    <section className={noBackground ? styles.loading : styles.loading_with_bg}>
      <Lottie
        className={`${styles.loaderAnimation} mt-3`}
        animationData={loaderAnimation}
        loop={true}
      />
      {text && <div className={styles.loaderText}>{text}</div>}
    </section>
  );
};

export default Loader;
